import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { institutionBarStyles } from '../../../../global/constants/theme/styles/components/institution-bar';
import { useBasePath } from '../../../../global/hooks/useBasePath';
import { NavigationContext } from '../../../../global/models/app-context-model';
import { Institution } from '../../../../global/models/institution-model';
import { TcsmStates } from '../../../../root/tcsm-model';
import { ArcRoutes } from '../../constants/routes';
import { SearchProps } from '../../models/arc-epi-props';
import { DioceseInstitutionItem, InstitutionItem } from './institution-model';

export const InstitutionInfoSection = () => {
	const classes = institutionBarStyles();
	const institution = useSelector<TcsmStates, Institution>(state => state.institutionState.currentInstitution);
	const currentDioceseInstitution = useSelector<TcsmStates, DioceseInstitutionItem>(state => state.institutionState.currentDioceseInstitution);
	const searchSettings = useSelector<TcsmStates, SearchProps>(state => state.epiProps?.searchSettingsState?.epiContent);
	const institutionSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.InstitutionRoot}${ArcRoutes.InstitutionSearch}`);
	const dioSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.DioceseRoot}`);
	const dioInstitutionSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.DioceseRoot}${ArcRoutes.InstitutionSearch}`);
	const userNavigationContext = useSelector<TcsmStates, NavigationContext>(state => state.appContext.userNavigationContext);

	const location = useLocation();
	const institutionList = useSelector<TcsmStates, InstitutionItem[]>(a => a.institutionState?.institutionList);
	const dioceseList = useSelector<TcsmStates, InstitutionItem[]>(a => a.institutionState?.dioceseList);
	const dioceseInstitutionList = useSelector<TcsmStates, DioceseInstitutionItem[]>(a => a.institutionState?.dioceseInstitutionList);

	let clientNumber = '';
	let organizationName = '';

	switch (userNavigationContext) {
		
		case NavigationContext.Institution:
		case NavigationContext.Diocese:
			clientNumber = institution?.org_client_nbr;
			organizationName = institution?.organization_name;
			
		break;

		case NavigationContext.DioceseInstitution:
			clientNumber = currentDioceseInstitution?.client_number;
			organizationName = currentDioceseInstitution?.organization_name;

		break;
	
		default:
			break;
	}	

	if (!institution || 
		(userNavigationContext !== NavigationContext.Institution && 
		userNavigationContext !== NavigationContext.Diocese && 
		userNavigationContext !== NavigationContext.DioceseInstitution)) {
		return null;
	}

	function InstitutionButton(){
		if (userNavigationContext !== NavigationContext.Institution) return null;

		if (!institutionList || institutionList?.length === 1) return null;

		return (
		<>
			<Link to={{ pathname: institutionSelect,
					state: {
						actionLink: location.pathname,
					},
			}} >{searchSettings?.changeInstitutionLabelText}</Link>
		</>);
	}

	function DioceseButton(){
		if (userNavigationContext !== NavigationContext.Diocese) return null;

		if (!dioceseList || dioceseList?.length === 1) return null;

		return (
		<>
			<Link to={{ pathname: dioSelect,
					state: {
						actionLink: location.pathname,
					},
			}} >{searchSettings?.changeDioLabelText}</Link>
		</>);
	}

	function DioceseInstituionButton(){
		if (userNavigationContext !== NavigationContext.DioceseInstitution) return null;

		if (!dioceseInstitutionList || dioceseInstitutionList?.length === 1) return null;

		return (
		<>
			<Link to={{ pathname: dioInstitutionSelect,
					state: {
						actionLink: location.pathname,
					},
			}} >{searchSettings?.changeInstitutionLabelText}</Link>
		</>);
	}

	return (
		<div className={classes.institutionBarContainer}>
			<p className='input-label institution-bar-number'>{searchSettings?.changeInstitutionLinkText}: {clientNumber}</p>
			<div className='institution-bar-inner'>
				<p className='institution-bar-name'>{organizationName}</p>
				<InstitutionButton/>
				<DioceseButton/>	
				<DioceseInstituionButton/>
			</div>
		</div>

	);
};